import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Carrot } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Carrot className="w-10 h-10 text-primary animate-pulse" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}
